import { render, staticRenderFns } from "./blog-title.vue?vue&type=template&id=3ae3571e&scoped=true&"
import script from "./blog-title.vue?vue&type=script&lang=js&"
export * from "./blog-title.vue?vue&type=script&lang=js&"
import style0 from "./blog-title.vue?vue&type=style&index=0&id=3ae3571e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae3571e",
  null
  
)

export default component.exports